(() => {
  if (window.__hhsVariantView) return;
  window.__hhsVariantView = true;

  const selector = '.variant-view-toggle[data-target-id]';
  const views = new Map();

  function savedView(id) {
    if (!views.has(id)) {
      let view = 'grid';
      try { if (sessionStorage.getItem('hoyostar-view:' + id) === 'list') view = 'list'; } catch (_) {}
      views.set(id, view);
    }
    return views.get(id);
  }

  function apply(button, view) {
    const list = document.getElementById(button.dataset.targetId);
    if (!list) return;
    if (list.dataset.variantView !== view) list.dataset.variantView = view;
    if (list.classList.contains('is-list-view') !== (view === 'list')) list.classList.toggle('is-list-view', view === 'list');
    if (button.dataset.currentView !== view) button.dataset.currentView = view;
    const label = view === 'list' ? button.dataset.gridLabel : button.dataset.listLabel;
    const pressed = String(view === 'list');
    if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
    if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
  }

  function init(root) {
    if (root.matches?.(selector)) apply(root, savedView(root.dataset.targetId));
    if (root === document || root.childElementCount) {
      root.querySelectorAll(selector).forEach(button => apply(button, savedView(button.dataset.targetId)));
    }
  }

  document.addEventListener('click', event => {
    const button = event.target.closest?.(selector);
    if (!button) return;
    const view = button.dataset.currentView === 'list' ? 'grid' : 'list';
    views.set(button.dataset.targetId, view);
    apply(button, view);
    try { sessionStorage.setItem('hoyostar-view:' + button.dataset.targetId, view); } catch (_) {}
  });
  init(document);
  new MutationObserver(records => {
    const roots = new Set();
    for (const record of records) {
      if (record.type === 'attributes') {
        const target = record.target;
        const id = record.attributeName === 'data-current-view' ? target.dataset.targetId : target.id;
        const current = record.attributeName === 'data-current-view' ? target.dataset.currentView : target.dataset.variantView;
        if (views.has(id) && current === views.get(id)) continue;
      }
      const picker = record.target.closest?.('variant-picker');
      if (picker) {
        roots.add(picker);
        continue;
      }
      for (const node of record.addedNodes) if (node.nodeType === 1) roots.add(node);
    }
    for (const root of roots) {
      if (!root.isConnected) continue;
      let parent = root.parentElement;
      while (parent && !roots.has(parent)) parent = parent.parentElement;
      if (!parent) init(root);
    }
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-variant-view', 'data-current-view'] });
})();
